import { IconProps } from "@/components";
import { h } from "omi";

export function RowsIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 16 16">
      <path
        d="M11.8667 6.66667c.7467 0 1.1201 0 1.4053-.14533.2509-.12783.4548-.3318.5827-.58269C14 5.65344 14 5.28007 14 4.53333v-.4c0-.74673 0-1.1201-.1453-1.40532-.1279-.25088-.3318-.45485-.5827-.58268C12.9868 2 12.6134 2 11.8667 2H4.13333c-.74673 0-1.1201 0-1.40532.14532a1.333462 1.333462 0 0 0-.58269.58269C2 3.01323 2 3.3866 2 4.13333v.4c0 .74674 0 1.12011.14532 1.40532.12784.25089.33181.45486.58269.58269.28522.14533.65859.14533 1.40532.14533h7.73337ZM11.8667 14c.7467 0 1.1201 0 1.4053-.1453.2509-.1279.4548-.3318.5827-.5827C14 12.9868 14 12.6134 14 11.8667v-.4c0-.7468 0-1.1201-.1453-1.4054-.1279-.25084-.3318-.45481-.5827-.58264-.2852-.14533-.6586-.14533-1.4053-.14533H4.13333c-.74673 0-1.1201 0-1.40532.14533a1.333505 1.333505 0 0 0-.58269.58264C2 10.3466 2 10.7199 2 11.4667v.4c0 .7467 0 1.1201.14532 1.4053.12784.2509.33181.4548.58269.5827C3.01323 14 3.3866 14 4.13333 14h7.73337Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
